import { render } from "./item-modal.vue?vue&type=template&id=05e1fd64&scoped=true"
import script from "./item-modal.vue?vue&type=script&lang=js"
export * from "./item-modal.vue?vue&type=script&lang=js"

import "./item-modal.vue?vue&type=style&index=0&id=05e1fd64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e1fd64"]])

export default __exports__